export default __webpack_public_path__ + "static/media/Phone_light.3b348b13.svg";